var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.773,
    height: 18.773,
    viewBox: "19.614 15.614 18.773 18.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 15.614A9.378 9.378 0 0 0 19.614 25 9.378 9.378 0 0 0 29 34.386 9.378 9.378 0 0 0 38.386 25 9.378 9.378 0 0 0 29 15.614Zm4.693 12.756-1.323 1.323-3.37-3.37-3.37 3.37-1.323-1.323 3.37-3.37-3.37-3.37 1.323-1.323 3.37 3.37 3.37-3.37 1.323 1.323-3.37 3.37 3.37 3.37Z",
    fill: "#b3b3b3",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 23"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.a14e2d173f872ea5011cd5b729c466a8.svg";
export { ForwardRef as ReactComponent };